// Lightweight PWA-install utilities shared by the dashboard banner,
// the post-install celebration strip, and the Settings panel row.

const KEY_COMPLETED_AT = "famfeel_install_completed_at";
const KEY_CELEBRATION_DISMISSED = "famfeel_install_celebration_dismissed";
const CELEBRATION_WINDOW_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

export const isStandalone = () => {
  if (typeof window === "undefined") return false;
  if (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) return true;
  if (window.navigator && window.navigator.standalone === true) return true;
  return false;
};

export const isIos = () => {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
};

export const markInstalled = () => {
  try {
    localStorage.setItem(KEY_COMPLETED_AT, String(Date.now()));
    // Let any mounted listener (e.g. celebration banner) react immediately.
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("famfeel:installed"));
    }
  } catch {}
};

export const getInstalledAt = () => {
  try {
    const raw = localStorage.getItem(KEY_COMPLETED_AT);
    return raw ? Number(raw) : 0;
  } catch { return 0; }
};

export const isCelebrationDismissed = () => {
  try { return localStorage.getItem(KEY_CELEBRATION_DISMISSED) === "1"; } catch { return false; }
};

export const dismissCelebration = () => {
  try { localStorage.setItem(KEY_CELEBRATION_DISMISSED, "1"); } catch {}
};

// Should we show the celebration bottom strip right now?
// → Yes if installed at any time within the last 7 days AND not dismissed.
export const shouldShowCelebration = () => {
  const at = getInstalledAt();
  if (!at) return false;
  if (Date.now() - at > CELEBRATION_WINDOW_MS) return false;
  if (isCelebrationDismissed()) return false;
  return true;
};
